var angular=window.angular,ngModule;
try {ngModule=angular.module(["ikeweb.templates"])}
catch(e){ngModule=angular.module("ikeweb.templates",[])}
var v1="<li class=\"NotesListitem MeasurementsDetail-measurementValue\" ng-class=\"activeIfSelected()\" ng-click=\"selectMe()\">\n<div class=\"ProBadgeContainer\">\n<div ng-show=\"!canMakeNote\" class=\"material-icons pro-lock pro-lock-small pro-lock-overlay\">lock_outline</div>\n<a title=\"{{ 'COMPONENT.NOTES_LISTITEM.CLICK_TO_EDIT' | translate }}\">\n<textarea class=\"NoteListitem-content\" placeholder=\"{{ (canMakeNote ? 'COMPONENT.NOTES_LISTITEM.ENTER_NOTES_HERE' : 'COMPONENT.NOTES_LISTITEM.GET_SPIKE_PRO_FOR_NOTES') | translate }}\" ng-model=\"note\" ng-readonly=\"!canMakeNote\" maxlength=\"1000\"></textarea>\n</a>\n<div ng-show=\"!canMakeNote\" class=\"ProBadge ProBadge--TopRight\">pro</div>\n</div>\n</li>";
var id1="notes.listitem.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/notes/notes.listitem.html
// module id = 456
// module chunks = 0